import { render, staticRenderFns } from "./PropertyEditDialog.vue?vue&type=template&id=b6cd528e&scoped=true"
import script from "./PropertyEditDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./PropertyEditDialog.vue?vue&type=style&index=0&id=b6cd528e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cd528e",
  null
  
)

export default component.exports